export const NAVBAR_GOOGLE_MOBILE_MAX_WIDTH = 768;
export const GIS_PERSONALIZED_MAX_PX = 400;
export const GIS_PERSONALIZED_MIN_PX = 200;
export const GIS_PAGE_GUTTER_PX = 48;

/**
 * Personalized "Sign in as …" chips need ~360–400px or GIS clips the G.
 * On phones, stay inside the page gutters.
 */
export function getPersonalizedGoogleButtonWidth(viewportWidth) {
  if (!viewportWidth) {
    return String(GIS_PERSONALIZED_MAX_PX);
  }

  const available = Number(viewportWidth) - GIS_PAGE_GUTTER_PX;
  return String(Math.max(
    GIS_PERSONALIZED_MIN_PX,
    Math.min(GIS_PERSONALIZED_MAX_PX, available),
  ));
}

export function isNavbarGoogleIcon(viewportWidth) {
  return Boolean(viewportWidth) && viewportWidth <= NAVBAR_GOOGLE_MOBILE_MAX_WIDTH;
}

/**
 * Standard GIS "Sign in" chips are at least 200px and crowd the wordmark
 * off a phone header. Use Google's 40px icon there; keep the full chip
 * on desktop. The landing hero still has the full button.
 */
export function getNavbarGoogleLoginProps(viewportWidth) {
  if (isNavbarGoogleIcon(viewportWidth)) {
    return {
      type: 'icon',
      size: 'large',
      shape: 'rectangular',
      text: 'signin',
    };
  }

  return {
    type: 'standard',
    size: 'large',
    shape: 'rectangular',
    text: 'signin',
    width: String(GIS_PERSONALIZED_MAX_PX),
  };
}
